import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Modules
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxEditorModule } from 'ngx-editor';
import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaModule } from 'ng-recaptcha';

// Strategies
import { LocationStrategy, HashLocationStrategy, PathLocationStrategy, DecimalPipe } from '@angular/common';

// App Settings
import { AppConfig, ServiceHelper } from './config';

// Modules
import { SharedModule } from './shared/shared.module';
import { AuctionModule } from './auction/auction.module';
import { InvoiceModule } from './invoice/invoice.module';
import { RemittanceModule } from './remittance/remittance.module';
import { BidModule } from './bid/bid.module';

// App Guards
import {
  SignedInGuard,
  AdminRoleGuard
} from './guards';
// App Services
import {
  AuthService,
  RoleService,
  StateService,
  GenericDataService,
  AnalyticsService,
  AuctionService,
  BidIncrementService,
  AuctionLotService,
  MyAuctionLotService,
  CustomerService,
  ScriptService,
  SquareService,
  SystemParametersService,
  WineService,
  InvoiceService,
  RemittanceService
} from './services'

// Page Components
import {
  PageHomeComponent,
  PageLoginComponent,
  PageForgotPasswordComponent,
  PageRegisterComponent,
  PageAboutHistoryComponent,
  PageAboutStaffComponent,
  PageAboutTermsComponent,
  PageProfileComponent,
  PageChangePasswordComponent
} from './pages';

import {
  Validations
} from './constants';

import {
  FormFunctions,
  CustomDateAdapter,
  CustomDateParserFormatter
} from './functions';

import {
  CustomerProfileComponent,
  CustomerRegistrationComponent,
  CustomerChangePasswordComponent
} from './components';

// Load the app config in a factory
export function appConfigFactory(provider: AppConfig) {
  return () => provider.load();
}

@NgModule({
  declarations: [
    AppComponent,
    PageHomeComponent,
    PageLoginComponent,
    PageForgotPasswordComponent,
    PageRegisterComponent,
    PageProfileComponent,
    CustomerRegistrationComponent,
    CustomerProfileComponent,
    PageAboutHistoryComponent,
    PageAboutStaffComponent,
    PageAboutTermsComponent,
    CustomerChangePasswordComponent,
    PageChangePasswordComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    NgSelectModule,
    NgbModule,
    NgxEditorModule,
    SharedModule,
    AuctionModule,
    BidModule,
    RecaptchaModule,
    InvoiceModule,
    RemittanceModule,
  ],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: APP_INITIALIZER, useFactory: appConfigFactory, deps: [AppConfig], multi: true },
    { provide: NgbDateAdapter, useClass: CustomDateAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    NgbTooltipConfig,
    SignedInGuard,
    AdminRoleGuard,
    AppConfig,
    Validations,
    FormFunctions,
    DecimalPipe,
    ServiceHelper,
    ScriptService,
    AuthService,
    RoleService,
    StateService,
    GenericDataService,
    AnalyticsService,
    AuctionService,
    BidIncrementService,
    AuctionService,
    AuctionLotService,
    MyAuctionLotService,
    CustomerService,
    SquareService,
    SystemParametersService,
    WineService,
    InvoiceService,
    RemittanceService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
